<template>
  <div class="countdown-container">
    <div class="mask"></div>
    <div class="tips-box">
      <div class="img-box">
        <img :src="require('@/assets/img/countDown.png')" />
        <div class="time-box">
          <span class="time">{{ time }}</span>
          <span class="unit">s</span>
        </div>
      </div>

      <div class="text-box">
        纹理应用成功，<span class="time">{{ time }}s</span>后重新加载页面
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 5,
    };
  },
  created() {
    this.updateTime();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    updateTime() {
      this.timer = setInterval(() => {
        this.time--;
        if (this.time === 1) {
          clearInterval(this.timer);
          window.location.reload();
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.countdown-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 3;
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--dialog-mask-bgColor)
  }

  .tips-box {
    position: absolute;
    top: calc(50% - 90px);
    left: calc(50% - 90px);

    .img-box {
      width: 150px;
      height: 150px;
      margin: auto;

      .time-box {
        margin-top: -120px;

        .time {
          font-size: 60px;
          color: var(--aside-bg-color);
        }

        .unit {
          font-size: 24px;
          color: var(--aside-bg-color);
        }
      }
    }

    .text-box {
      margin-top: 5px;
      font-size: 18px;
      color: var(--aside-bg-color);
      .time {
      font-size: 18px;
        color: var(--base-primary-color);
      }
    }
  }
}
</style>